import {Component} from "@angular/core";

@Component({
    selector: "fui-modal-window-header",
    templateUrl: "./modal-window-header.component.html"
})
export class FUIModalWindowHeaderComponent {
    constructor() {

    }
}
